import { useContext } from 'react';
import { AnalyticsContext } from './AnalyticsContext';
/**
 * Hook to access MSRC's preconfigured analytics provider.
 */
export const useAnalytics = () => {
    const { appInsights, reactPlugin } = useContext(AnalyticsContext);
    return { appInsights, reactPlugin };
};
